// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { dodochainTestnet as _dodochainTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the dodochainTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 53457
 * Chain Name: DODOchain Testnet
 * Default Block Explorer: https://testnet-scan.dodochain.com
 * Default RPC URL: https://dodochain-testnet.alt.technology
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { dodochainTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: dodochainTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const dodochainTestnet = createCommon({
	..._dodochainTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
